
define('template!mailsMailHeaderLabelsAddView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body">\n  <div class="body-content">\n    <input list="mails-labels-' +
((__t = ( id )) == null ? '' : __t) +
'"/>\n    <div class="mails-labels-region"></div>\n  </div>\n</div>\n<div class="footer">\n  <div class="left">\n    <div class="load">\n      <div class="loader-2"></div>\n      <div class="text"></div>\n    </div>\n  </div>\n  <div class="right">\n    <div class="cancel-region"></div>\n    <div class="confirm-region"></div>\n  </div>\n</div>\n<datalist id="mails-labels-' +
((__t = ( id )) == null ? '' : __t) +
'">\n  <option value="France">\n  <option value="Germany">\n  <option value="Italy">\n</datalist>';

}
return __p
};});

